import { connect } from 'react-redux'
import { login } from './actions/auth'
import App from './App'

const mapStateToProps = (state) => {
    return {
        user: state.user,
        modalStates: state.modalStates,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onClick: (data) => {
            dispatch(login(data))
        },
    }
}

const AppContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(App)

export default AppContainer
